/* fh-sleeve.js [CUSTOM, Diwali, 2026-10-10] · the festive sleeve opt-in in the bag.
 *
 * Markup: snippets/fh-sleeve.liquid. Loaded once from sections/cart-drawer.liquid, outside #CartDrawer, so it
 * survives the drawer's innerHTML re-render; listeners are delegated on document.
 *
 * The write is fh-rakhi.js's (Aug 2026): a line item property on the qualifying line. POST /cart/change.js REPLACES
 * the whole properties object, so the line's current properties are re-read and merged first, or a trio would lose
 * its Scent 1/2/3 and a Decoder pod its _decoder. https://shopify.dev/docs/api/ajax/reference/cart
 *
 * The card flips the moment it is tapped (the sleeve's band runs across, the bag line gets its band), then the write
 * goes out; the final state is read from the cart that comes back, and a failed write flips it back and says so.
 */
(function () {
  var busy = false;

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }
  function changeUrl() {
    return (window.routes && window.routes.cart_change_url) || root() + 'cart/change.js';
  }
  function cartUrl() {
    return (window.routes && window.routes.cart_url ? window.routes.cart_url + '.js' : root() + 'cart.js');
  }

  function paint(btn, on) {
    btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    var panel = btn.closest('.fhcd-panel');
    if (panel) panel.classList.toggle('fh-sl-on', on);
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-fh-sleeve]');
    if (!btn) return;
    e.preventDefault();
    if (busy) return;
    toggle(btn);
  });

  // The tick outside the bag (Decoder results, gift set pages: snippets/fh-sleeve-strip.liquid) only holds the choice;
  // assets/quiz.js and assets/fh-pdp.js read it when they add to the cart, since those buttons go straight to GoKwik.
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-fh-sleeve-opt]');
    if (!t) return;
    e.preventDefault();
    var on = t.getAttribute('aria-pressed') !== 'true';
    t.setAttribute('aria-pressed', on ? 'true' : 'false');
    var s = t.parentNode && t.parentNode.querySelector('[data-fh-sleeve-opt-status]');
    if (s) s.textContent = (t.getAttribute('data-fh-sleeve-prop') || 'Diwali Sleeve') + (on ? ' added' : ' removed');
  });

  function toggle(btn) {
    busy = true;
    btn.classList.add('is-busy');
    var wrap = btn.closest('.fh-sl');
    var err = wrap && wrap.querySelector('.fh-sl__err');
    var status = wrap && wrap.querySelector('[data-fh-sleeve-status]');
    if (err) err.hidden = true;

    var prop = btn.getAttribute('data-fh-sleeve-prop') || 'Diwali Sleeve';
    var turnOn = btn.getAttribute('aria-pressed') !== 'true';
    var line = parseInt(btn.getAttribute(turnOn ? 'data-fh-sleeve-target' : 'data-fh-sleeve-line'), 10);
    paint(btn, turnOn);

    fetch(cartUrl(), { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var item = cart.items && cart.items[line - 1];
        if (!item) throw new Error('line ' + line + ' is no longer in the cart');
        // Re-send every existing property. change.js replaces the whole object.
        var props = {};
        Object.keys(item.properties || {}).forEach(function (k) { props[k] = item.properties[k]; });
        if (turnOn) {
          props[prop] = 'Yes';
        } else {
          delete props[prop];
          // change.js IGNORES an empty properties object (probed 10 Oct: {} left "Yes" in place), so a gift set with no
          // other property says "No" instead; only "Yes" means a sleeve, for the theme and for the packer.
          if (!Object.keys(props).length) props[prop] = 'No';
        }
        return fetch(changeUrl(), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ line: line, properties: props })
        });
      })
      .then(function (r) { return r.json(); })
      .then(function (state) {
        if (state.status) throw new Error(state.description || state.message || 'change.js rejected the write');
        // Settle on what the cart says, not on what was asked for.
        var items = state.items || [];
        var at = -1;
        for (var i = 0; i < items.length; i++) {
          if (items[i].properties && items[i].properties[prop] === 'Yes') { at = i; break; }
        }
        btn.setAttribute('data-fh-sleeve-line', String(at >= 0 ? at + 1 : btn.getAttribute('data-fh-sleeve-target')));
        paint(btn, at >= 0);
        if (status) status.textContent = at >= 0 ? prop + ' added' : prop + ' removed';
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: JSON.stringify(state) } }));
      })
      .catch(function (e) {
        paint(btn, !turnOn);
        if (err) err.hidden = false;
        console.warn('[fh-sleeve]', e);
      })
      .finally(function () {
        busy = false;
        btn.classList.remove('is-busy');
      });
  }
})();
